import { AdvancedRange } from "../containers/Lab/LabPrint/LabPrintFunctions";
import { PassportInfo } from "../models/Client";
import { ServiceProvider } from "./ServiceProvidersInterface";
import { LabFormData, Range, TestTypes } from "./Lab";

export interface LabAttachment {
  id: number;
  fileName: string;
  s3ResourceURL: string;
  s3ResourceKey: string;
  downloadLink: string;
}

export interface LabTest {
  id: number;
  name: string;
  code: string;
  common?: boolean;
  type?: TestTypes;
  unit: string;
  specimen: string;
  methods: string;
  category: string;
  parentId: number | null;
  info?: { defaultValue: string };
  ranges: AdvancedRange | null;
  defaultValue?: string;
}

export interface LabObject {
  id: number;
  clientId: number;
  serviceProviderId: number;
  assessmentId: number;
  resourceCentreId: number;
  status: string;
  collectionDate: string;
  resultDate: string;
  results: Record<string, unknown>;
  type: string;
  remarks: Array<{ id: number; date: string; name: string; remark: string }>;
  uuid: string;
  parentId: number;
  client: LabObjectClient;
  customer: LabObjectCustomer;
  referrers?: string;
  extraReferrer?: { name: string; id: number };
  labIdentifier?: string;
  serviceProvider: ServiceProvider;
  labTestNumber: string;
  labCreatedTime: string;
  // eslint-disable-next-line camelcase
  created_at: string;
  // eslint-disable-next-line camelcase
  updated_at: string;
  labRecordAttachments?: LabAttachment[];
}

export interface LabObjectClient {
  id: number;
  firstName: string;
  lastName: string;
  phone: string;
  active: boolean;
  email: string;
  sendEmail: boolean;
  dob: string;
  gender: string;
  registrationNo: string;
  ipdNo: string;
  passportInfo: PassportInfo;
  address: string;
  displayName: string;
  nationality: string;
}

export interface LabObjectCustomer {
  id: number;
  clientId: number;
  customerNumber: string;
  customerDetails: { [key: string]: string | number };
  externalIdentifier: string;
}

export interface LabPrintSettings {
  showLetterhead: boolean;
  showFooter: boolean;
  headerColor: string;
  dateSetting: string;
  showSampleTakenTime: boolean;
  showReportOnTime: boolean;
  showPrintedOnTime: boolean;
  showSampleTakenDate: boolean;
  showReportOnDate: boolean;
  showQrWhenFooterIsHidden: boolean;
  showPrintedOnDate: boolean;
  spaciousMargins: boolean;
  template: string;
  centralizedHeader: boolean;
  additionallabdata: boolean;
  clinicNameFontScale: number;
  labRemarks: string;
  showLabRemarks: boolean;
  showMethods: boolean;
  showRanges: boolean;
  showUnit: boolean;
  showReading: boolean;
  showPhoto: boolean;
  showCustomerIdentifier: boolean;
  customTitle: string;
  govTemplateHeaderText1?: string;
  govTemplateHeaderText2?: string;
  hideFooterLogoCompletely: boolean;
  categoryOrder?: Array<{ id: number; category: string }>;
  showRangeFlag: boolean;
  useCustomLabTestNumber: boolean;
  showSampleCollectedBy: boolean;
  customHeaderImage: string;
  showAttachmentOnlyInPrint: boolean;
}

export enum DiagnosticTypes {
  PATHOLOGY = "pathology",
  RADIOLOGY = "radiology",
  CYTOLOGY = "cytology"
}

export interface LabTestGroup {
  category: string;
  code: string;
  common: boolean;
  email: string;
  id: number;
  labTests: Test[];
  name: string;
  type: DiagnosticTypes;
}

export interface Test {
  additionalTestData: string;
  category: string;
  code: string;
  // eslint-disable-next-line camelcase
  created_at: string;
  id: number;
  methods: string;
  name: string;
  parentId: number;
  ranges: Range;
  sortCode: string;
  specimen: string;
  formData: LabFormData;
  subTests?: Test[];
  unit: string;
  // eslint-disable-next-line camelcase
  updated_at: string;
  info: { [key: string]: string | number };
}

export enum RangesTypes {
  default = "default",
  male = "male",
  female = "female"
}

export type SubTest = Test;
